<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <div style="padding-bottom: 10px;">
          <el-switch v-if="obj.supplierType=='PLANT'" v-model="groupOrfacility" active-text="Group" inactive-text="Facility" @change='changeGroupOrfacility'></el-switch>
          <el-switch v-if="obj.supplierType=='DC'" v-model="groupOrfacility" active-text="Group" inactive-text="DC" @change='changeGroupOrfacility'></el-switch>
        </div>
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="140px">
          <el-row>
            <!-- 供应商编码/邀请码 -->
            <el-col :span="8">
              <el-form-item :label="$t('settlementUnit.suppliercodeOrInvitationCode')" prop="invitationSupplierCode">
                <el-input v-model="queryCondition.invitationSupplierCode" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- 供应商简称-->
            <el-col :span="8">
              <el-form-item :label="$t('supplierManage.supplierAbbreviation')" prop="supplierNameShort">
                <el-input v-model="queryCondition.supplierNameShort" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结算单位编码" prop="otherCode">
                <el-input v-model="queryCondition.otherCode" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="结算单位名称" prop="otherName">
                <el-input v-model="queryCondition.otherName" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- Facility Name-->
            <el-col :span="8" v-if="!groupOrfacility && obj.supplierType=='PLANT'">
              <el-form-item :label="$t('BC.FactoryName')" prop="plantName">
                <el-input v-model="queryCondition.plantName" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- DC名称 -->
            <!-- groupOrfacility为false代表是DC,为true代表是Group -->
            <el-col :span="8" v-if="!groupOrfacility && obj.supplierType=='DC'">
              <el-form-item :label="$t('DC.supplierName')" prop="plantName">
                <el-input v-model="queryCondition.plantName" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button class="btn" @click="onSearch(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table" row-key="tmSupplierId" @selection-change="handleSelectionChange" ref="supplierSelectTabel">
        <el-table-column v-if="multipleSelectionFlag && !groupOrfacility" sortable prop="tmSupplierId" type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
        <el-table-column align="center" v-else width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmSupplierId"></el-radio>
          </template>
        </el-table-column>
        <!--供应商编码-->
        <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('settlementUnit.suppliercodeOrInvitationCode')"></el-table-column>
        <!--供应商简称-->
        <el-table-column show-overflow-tooltip prop="supplierNameShort" :label="$t('supplierManage.supplierAbbreviation')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="otherCode" label="结算单位编码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="otherName" label="结算单位名称"></el-table-column>
        <!--DC名称-->
        <el-table-column show-overflow-tooltip prop="plantName" v-if="obj.supplierType=='DC' && !groupOrfacility" :label="$t('base.dc.dcName')"></el-table-column>
        <!--Facility Name-->
        <el-table-column show-overflow-tooltip prop="plantName" v-if="obj.supplierType=='PLANT' && !groupOrfacility" :label="$t('visitPlan.FactoryName')"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import supplierApi from "@/api/supplier/supplier";
import { apiService } from "@/api/material/material-master-data";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import utils from "@/utils/commonFun";

export default {
  name: 'supplier-sel-page',
  props: {
    // tmSupplierId: {
    //   type: String,
    //   default: ''
    // },
    // type: {
    //   type: String,
    //   default: ''
    // },
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
    },
    params: {
      type: String,
    }
  },
  data() {
    return {
      tableData: [],
      totalCount: 0,
      statusList: [], // 状态列表
      queryCondition: {
        invitationSupplierCode: '',
        otherName: '',
        otherCode: '',
        supplierNameShort: '',
        supplierName: '',
        categoryLevel1Id: '',
        categoryLevel2Id: '',
        pageNum: 1,
        pageSize: 15,
        supperSupplierId: '',
        plantName: '',
        departmentList: ['MDM', 'SS', 'NFC'],
        scoped: true,
        type: "",
      },
      multipleSelection: [],
      supplierStatusList: [],
      getRowKeys(row) {
        return row.tmSupplierId;
      },
      selectRows: [],
      radioVal: null,
      categoryList1: [],
      categoryList2: [],
      groupOrfacility: false,
      obj: {}
    }
  },
  created() {
    // this.queryData();
    this.getCategoryList()
  },
  watch: {
    visible() {
      this.$refs.supplierSelectTabel.clearSelection();
    },
    // tmSupplierId(val) {
    //   this.queryData()
    // },
    // type(val) {
    //   this.queryCondition.type = this.type;
    //   this.queryData();
    // },
    params: {
      handler(newV, oldV) {
        console.log("🚀 ~ file: dc-plant-sel-page.vue:163 ~ handler ~ newV:", newV)
        if (newV) {
          this.obj = Object.assign({}, JSON.parse(newV))
          this.queryCondition.type = JSON.parse(newV).supplierType;
          this.tmDcIds = JSON.parse(newV).tmDcIdArr
          this.queryData();
        }
      },
      immediate: true
    }
  },
  methods: {
    restQueryForm() {
      this.queryCondition = {
        invitationSupplierCode: '',
        otherName: '',
        otherCode: '',
        supplierNameShort: '',
        supplierName: '',
        categoryLevel1Id: '',
        categoryLevel2Id: '',
        pageNum: 1,
        pageSize: 15,
        supperSupplierId: '',
        plantName: '',
        departmentList: ['MDM', 'SS', 'NFC'],
        scoped: true,
        type: "",
      }
      this.multipleSelection = []
      this.selectRows = [];
      this.$refs.supplierSelectTabel.clearSelection();
      this.queryData()
    },
    onSearch(val) {
      this.$nextTick(() => {
        this.$refs.supplierSelectTabel.clearSelection();
      })
      let that = this;
      if (undefined != val) {
        that.queryCondition.pageNum = 1;
      }
      if (that.groupOrfacility) {
        // 查询group
        that.queryCondition.status = '1'
        that.queryCondition.auditStatus = 'PASS'
        delete that.queryCondition.supperSupplierId;
        console.log("🚀 ~ file: dc-plant-sel-page.vue:208 ~ queryData ~ that.queryCondition:", that.queryCondition)
        supplierApi.getResourceList(that.queryCondition).then((res) => {
          that.tableData = res.resultData;
          that.totalCount = res.totalCount;
        })
      } else {
        // 查询dc
        delete that.queryCondition.status;
        delete that.queryCondition.auditStatus;
        that.queryCondition.type = that.obj.supplierType;
        supplierApi.searchGroupPlant(that.queryCondition).then((res) => {
          that.tableData = res.resultData;
          that.totalCount = res.totalCount;
        })
      }
    },
    //facility
    queryData(val) {
      // if (utils.isNotEmpty(this.tmDcIds)) {
      // }
      let that = this;
      if (undefined != val) {
        that.queryCondition.pageNum = 1;
      }
      if (that.groupOrfacility) {
        that.queryCondition.status = '1'
        that.queryCondition.auditStatus = 'PASS'
        delete that.queryCondition.supperSupplierId;
        console.log("🚀 ~ file: dc-plant-sel-page.vue:208 ~ queryData ~ that.queryCondition:", that.queryCondition)
        supplierApi.getResourceList(that.queryCondition).then((res) => {
          that.tableData = res.resultData;
          that.totalCount = res.totalCount;
          that.$nextTick(() => {
            that.tableData.forEach(ele => {
              if (that.tmDcIds.includes(ele.tmSupplierId)) {
                that.$refs.supplierSelectTabel.toggleRowSelection(ele, true);
              } ele
            })
          })
        })
      } else {
        delete that.queryCondition.status;
        delete that.queryCondition.auditStatus;
        that.queryCondition.type = that.obj.supplierType;
        supplierApi.searchGroupPlant(that.queryCondition).then((res) => {
          that.tableData = res.resultData;
          that.totalCount = res.totalCount;
          that.$nextTick(() => {
            that.tableData.forEach(ele => {
              if (that.tmDcIds.includes(ele.tmSupplierId)) {
                that.$refs.supplierSelectTabel.toggleRowSelection(ele, true);
              }
            })
          })
        })
      }

    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.categoryList2 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
    clickSelectMethod: function () {
      //BC仅可选择唯一供应商
      let arr = this.selectRows
      console.log("🚀 ~ file: dc-plant-sel-page.vue:283 ~ arr:", arr)
      console.log('obj', this.obj)
      let flag = true
      if (arr.length > 0) {
        arr.some(function (value, index) {
          if (value.supplierCode !== arr[0].supplierCode) {
            flag = false
          }
        })
      } else {
        this.$emit('subCallMethod', this.selectRows, this.groupOrfacility)
      }

      if (flag) {
        this.$emit('subCallMethod', this.selectRows, this.groupOrfacility)
      } else {
        this.$message({
          message: '仅可选择同一供应商',
          type: "warning"
        });
      }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
    changeGroupOrfacility(val) {
      console.log("🚀 ~ file: dc-plant-sel-page.vue:328 ~ changeGroupOrfacility ~ val:", val)
      this.selectRows = [];
      this.$refs.supplierSelectTabel.clearSelection();
      this.radioVal = null
      this.queryData()
    }
  },
  extends: commonFunction
}
</script>
<style scoped>
.el-select {
  width: 100%;
}
</style>
